<template>
  <div id="app" class="__full">
    <router-view></router-view>
  </div>
</template>

<script>
  import '@style/reset.css'
  import '@style/iconfont.css'
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  .__full {
    width: 100%;
    height: 100%;
  }

  #nprogress {
    .spinner {
      display: none;
    }
    .bar {
      background-image: linear-gradient(-90deg, #FC6F33 0%, #FFCC66 100%);
      border-radius: 5px;
      height: 3px;
      .peg {
        box-shadow: none;
      }
    }
  }
</style>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// App.vue?9b0138d0